"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M8.3486 9.5823c1.117-.4888 2.4544-.5843 3.6518-.5843 1.1973 0 2.5342.0956 3.6511.584l-.7969 1.8344c-.8866-.3526-1.9147-.4184-2.8542-.4184s-1.9676.0658-2.8541.4184l-.7977-1.834zm0 4.8295.7977-1.834c.8865.3525 1.9146.4183 2.8541.4183.9395 0 1.9676-.0658 2.8542-.4183l.7969 1.8343c-1.1169.4884-2.4538.584-3.6511.584-1.1974 0-2.5348-.0955-3.6518-.5843z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4449 14.4396c-.4342.2156-.9311.4061-1.4968.5704l-.6179 3.1151C16.3256 18.9324 14.1728 19.5 12 19.5c-1.9682 0-3.9428-.4929-5.6985-1.3781l-1.2326-3.107c-.5727-.1654-1.0753-.3575-1.5138-.5753C2.0461 13.6899 1 12.3598 1 10.6324c0-1.4964.6921-2.9819 2.4966-4.033C5.2226 5.5937 7.9334 5 12 5c4.0666 0 6.7773.5938 8.5034 1.5993C22.3079 7.6505 23 9.136 23 10.6324c0 1.7274-1.0461 3.0575-2.5551 3.8072zM5 12.8881c-1.0051-.3783-2-1.0659-2-2.2557 0-.876.39-1.8227 2-2.5614v4.8171zm2 1.5708V7.4375C8.2598 7.1677 9.8943 7 12 7s3.7402.1677 5 .4375v7.1143l-.4167 2.1009C15.1145 17.152 13.5555 17.5 12 17.5c-1.4078 0-2.8296-.3061-4.1294-.8464L7 14.4589zm12-1.5708V8.071c1.6101.7387 2 1.6854 2 2.5614 0 1.1898-.9949 1.8774-2 2.2557z"
  })];
};

exports.default = _default;